var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane fade",attrs:{"id":"Invoices","role":"tabpanel","aria-labelledby":"Invoices-tab"}},[_c('TransactionsTable',{attrs:{"title":'Recent',"params":_vm.params,"source":'invoices'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }